import Vue from "vue";
import "./plugins/axios";
import DashboardPlugin from "./material-dashboard";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";
import { KeycloakPlugin } from "./Auth";
import router from "./routes";
import store from "./store";

// plugin setup
Vue.use(DashboardPlugin);

// Install the authentication plugin here
Vue.use(KeycloakPlugin, {
  url: process.env.VUE_APP_KEYCLOAK_URL,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID
});

// global library setup
Object.defineProperty(Vue.prototype, "$Chartist", {
  get() {
    return this.$root.Chartist;
  }
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  data: {
    Chartist: Chartist
  },
  render: h => h(App)
});
